import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import SubAbasDocumentos from './subabasDocumentos';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useTipoExtensaoDocumento } from '../../../../services/enum/useExtensaoDocumento';
import { useStatusDocumento } from '../../../../services/enum/useStatusDoc';
import { useTipoDocumento } from '../../../../services/enum/useTipoDocumento';
import { getDocumentosGestaoSisaf } from '../../../../services/gestaoSisAF/documentosSisAfService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { formataNomeMeioSiglas } from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../utils/swal';

export default function DocumentosFicha() {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const tipoDocumento = useTipoDocumento();
  const tipoExtensao = useTipoExtensaoDocumento();
  const statusDocumento = useStatusDocumento();

  const responsavelDocumento = [
    { value: 1, label: 'Não informado' },
    { value: 2, label: 'Ângelo Morais' },
    { value: 3, label: 'Allan Ribeiro' },
    { value: 4, label: 'Jackson Ramos' },
    { value: 5, label: 'Mateus Farias' },
    { value: 99, label: 'Outro' },
  ];

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formDocumento, setFormDocumento] = useState({
    usuarioId: userID,
    tipoDocumento: 0,
    extensaoDocumento: 0,
    dataCriacao: '',
    responsavelDocumentoOption: 0,
    responsavelDocumento: '',
    responsavelOutro: '',
    localizador: '',
    titulo: '',
    resumo: '',
    statusDoc: '',
    link: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getDocumentosGestaoSisaf(id);
      setLogData(registroData);

      const dataCriacao = registroData.dataCriacao
        ? new Date(registroData.dataCriacao).toISOString().split('T')[0]
        : '';

      // Procurar o responsavelDocumento na lista de opções
      const responsavelEncontrado = responsavelDocumento.find(
        (option) => option.label === registroData.responsavelDocumento,
      );

      let responsavelDocumentoOption;
      let responsavelOutro = '';

      if (responsavelEncontrado) {
        // Se o responsável for encontrado, usar o value correspondente
        responsavelDocumentoOption = responsavelEncontrado.value;
      } else {
        // Se não for encontrado, definir como "Outro" (99) e preencher o campo responsavelOutro
        responsavelDocumentoOption = 99;
        responsavelOutro = registroData.responsavelDocumento;
      }

      setFormDocumento({
        usuarioId: userID,
        tipoDocumento: registroData.tipoDocumento,
        extensaoDocumento: registroData.extensaoDocumento,
        dataCriacao,
        responsavelDocumentoOption, // Preenchendo responsavelDocumentoOption corretamente
        responsavelDocumento: registroData.responsavelDocumento,
        responsavelOutro, // Preencher o campo de "Outro" se necessário
        localizador: registroData.localizador,
        titulo: registroData.titulo,
        resumo: registroData.resumo,
        statusDoc: registroData.statusDoc,
        link: registroData.link,
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //
  const [statusDocumentoStyle, setStatusDocumentoStyle] =
    useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';

    const status = String(formDocumento.statusDoc);

    const newStatusDocumentoStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? verde
            : status === '3'
              ? vermelho
              : 'white',
    };

    setStatusDocumentoStyle(newStatusDocumentoStyle);
  }, [formDocumento.statusDoc]);

  const [isResponsavelOutroReadOnly, setIsResponsavelOutroReadOnnly] =
    useState(false);
  useEffect(() => {
    if (formDocumento.responsavelDocumentoOption == 99) {
      setIsResponsavelOutroReadOnnly(false);
    } else {
      setIsResponsavelOutroReadOnnly(true);
      setFormDocumento((prev) => ({
        ...prev,
        responsavelOutro: '',
      }));
    }
  }, [formDocumento.responsavelDocumentoOption]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasDocumentos(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/maisopcoes/documentos/ficha/dadosgerais`,
      },
    ];
  }

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    setFormDocumento((prevState) => {
      let updatedValue = { [name]: value };

      // Se o campo alterado for o responsavelDocumentoOption
      if (name === 'responsavelDocumentoOption') {
        // Verifica se a opção "Outro" foi selecionada
        if (Number(value) === 99) {
          updatedValue = {
            ...updatedValue,
            responsavelDocumento: prevState.responsavelOutro, // Usar valor do campo "responsavelOutro"
          };
        } else {
          // Caso contrário, define o responsável como a label da opção selecionada
          const selectedOption = responsavelDocumento.find(
            (option) => option.value === Number(value),
          );
          updatedValue = {
            ...updatedValue,
            responsavelDocumento: selectedOption ? selectedOption.label : '',
          };
        }
      }

      // Se o campo alterado for o "responsavelOutro" e a opção "Outro" estiver selecionada
      if (
        name === 'responsavelOutro' &&
        Number(prevState.responsavelDocumentoOption) === 99
      ) {
        updatedValue = {
          ...updatedValue,
          responsavelDocumento: value, // Atualiza o responsavelDocumento com o valor de "responsavelOutro"
        };
      }

      return {
        ...prevState,
        ...updatedValue,
      };
    });
  };

  const validateForm = (formDocumento: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!formDocumento.statusDoc) {
      errors.push('<b>Status</b> do Documento é obrigatório.');
    }

    if (!formDocumento.dataCriacao) {
      errors.push('<b>Data</b> da Criação é obrigatório.');
    }

    if (!formDocumento.tipoDocumento) {
      errors.push('<b>Tipo</b> de Documento é obrigatório.');
    }

    if (!formDocumento.extensaoDocumento) {
      errors.push('<b>Extensão</b> do Documento é obrigatório.');
    }

    if (!formDocumento.responsavelDocumentoOption) {
      errors.push('<b>Responsável</b> pelo documento é obrigatório.');
    }

    if (
      formDocumento.responsavelDocumentoOption == 99 &&
      formDocumento.responsavelDocumento == ''
    ) {
      errors.push('<b>Responsável</b> pelo documento é obrigatório.');
    }

    if (!formDocumento.titulo) {
      errors.push('<b>Título</b> do documento é obrigatório.');
    }

    if (!formDocumento.resumo) {
      errors.push('<b>Descrição</b> do documento é obrigatório.');
    }

    if (!formDocumento.link) {
      errors.push('<b>Link</b> do documento é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formDocumento);
      if (!isFormValid) return;

      // Criar uma cópia de formDocumento excluindo o campo 'responsavelDocumentoOption'
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { responsavelDocumentoOption, responsavelOutro, ...formToSend } = {
        ...formDocumento,
        tipoDocumento: Number(formDocumento.tipoDocumento),
        extensaoDocumento: Number(formDocumento.extensaoDocumento),
        statusDoc: Number(formDocumento.statusDoc),
        dataCriacao: formDocumento.dataCriacao
          ? formDocumento.dataCriacao
          : null,
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(
        `/api/documentossisdaf/`,
        formToSend,
      );

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/maisopcoes/documentos/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formDocumento);
      if (!isFormValid) return;

      // Criar uma cópia de formDocumento excluindo o campo 'responsavelDocumentoOption'
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { responsavelDocumentoOption, responsavelOutro, ...formToSend } = {
        ...formDocumento,
        tipoDocumento: Number(formDocumento.tipoDocumento),
        extensaoDocumento: Number(formDocumento.extensaoDocumento),
        statusDoc: Number(formDocumento.statusDoc),
        dataCriacao: formDocumento.dataCriacao
          ? formDocumento.dataCriacao
          : null,
      };

      const response = await httpClient.patch(
        `/api/documentossisdaf/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }
    if (result) {
      try {
        await httpClient.delete(`/api/documentossisdaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/documentos');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    }
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/maisopcoes/documentos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} entity="TB_DOCUMENTO_SISAF" id={Number(fichaID)} />

          <BoxConteudo boxTitulo="Documento">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="200px">
                <Input
                  name="localizador"
                  label="Localizador"
                  value={formDocumento.localizador}
                  id="localizador"
                  onChange={handleChange}
                />
              </CustomCol>

              <CustomCol width="200px">
                <SelectInput
                  name="statusDoc"
                  options={statusDocumento}
                  label="Status"
                  value={formDocumento.statusDoc}
                  onChange={handleChange}
                  style={statusDocumentoStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataCriacao"
                  label="Data da Criação"
                  value={formDocumento.dataCriacao}
                  id="dataCriacao"
                  onChange={handleChange}
                  type="date"
                  required
                />
              </CustomCol>
              <CustomCol width="375px">
                <SelectInput
                  name="tipoDocumento"
                  options={tipoDocumento}
                  label="Tipo de Documento"
                  value={formDocumento.tipoDocumento}
                  onChange={handleChange}
                  required
                />
              </CustomCol>

              <CustomCol width="200px">
                <SelectInput
                  name="extensaoDocumento"
                  options={tipoExtensao}
                  label="Extensão"
                  value={formDocumento.extensaoDocumento}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="220px">
                <SelectInput
                  name="responsavelDocumentoOption"
                  options={responsavelDocumento}
                  label="Responsável"
                  value={formDocumento.responsavelDocumentoOption}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="responsavelOutro"
                  label="Outro"
                  value={formDocumento.responsavelOutro}
                  id="responsavelOutro"
                  onChange={handleChange}
                  readonly={isResponsavelOutroReadOnly}
                />
              </CustomCol>
            </CustomRow>

            {/* Título */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="titulo"
                  label="Título"
                  value={formDocumento.titulo}
                  id="titulo"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>

            {/* Resumo */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="resumo"
                  label="Resumo"
                  value={formDocumento.resumo}
                  id="resumo"
                  onChange={handleChange}
                  type="textarea"
                  linhas={5}
                  required
                />
              </CustomCol>
            </CustomRow>

            {/* Link */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="link"
                  label="Link"
                  value={formDocumento.link}
                  id="link"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formDocumento.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>
      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
